var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alarm"},[_c('div',{ref:"refEchart",staticClass:"echart"}),_c('AlarmTable',{attrs:{"visible":_vm.alarmShow,"id":_vm.id},on:{"update:visible":function($event){_vm.alarmShow=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }